<template>
  <form-select
    :loading="loading"
    :options="roleOptions"
    v-model="val"
    @visible-change="visibleChange"
    filterable
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
export default {
  name: 'form-select-role',
  props: {
    value: [String, Array],
    projectid: String
  },
  data() {
    return {
      roleOptions: [],
      loading: false
    }
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  created() {
    this.refreshRoleOptions()
  },
  methods: {
    visibleChange(visible) {
      if (visible && this.roleOptions.length == 0) {
        this.refreshRoleOptions()
      }
    },
    refreshRoleOptions() {
      this.loading = true
      this.$get('/project/role', {
        id: this.projectid
      })
        .then((resp) => {
          this.loading = false
          if (resp.data.code == 0) {
            this.roleOptions = resp.data.data.map((item) => {
              return {
                label: item.name,
                value: item.id
              }
            })
          } else {
            this.$message(`获取角色选项失败=>${resp.data.msg}`)
          }
        })
        .catch((err) => {
          this.loading = false
          console.error('获取角色选项发生异常:', err)
          this.$message(`获取角色选项发生异常=>${err}`)
        })
    }
  }
}
</script>
